export const narrowHeaderIconButtonSx = {
  '& > svg': {
    fontSize: '24px',
    width: '24px',
    height: '24px',
  },
} as const;

export const widgetHeaderActionSpacing = (isXs: boolean) => (isXs ? 1 : 0.25);
